/**
 * Responsive image derivatives.
 *
 * Generated from each photograph's original source CDN, which resizes and
 * re-encodes without any local encoder — none is installed, and the project
 * rule is not to add one for this.
 *
 * A format is listed only where it genuinely wins at EVERY width. WebP must
 * beat that image's own JPEG; AVIF is served first, so it must beat both the
 * JPEG and the WebP it would pre-empt — otherwise offering it makes the page
 * slower than not offering it. Four images were recompressed in place in an
 * earlier commit and have no recoverable source URL, so they have no AVIF.
 */
export const DERIVATIVES = {
  "/images/kitchen-3.jpg": {
    "base": "/images/derived/kitchen-3",
    "widths": [
      400,
      800
    ],
    "avif": false,
    "webp": true
  },
  "/images/cabinets-1.jpg": {
    "base": "/images/derived/cabinets-1",
    "widths": [
      400,
      800
    ],
    "avif": false,
    "webp": true
  },
  "/images/plumbing-1.jpg": {
    "base": "/images/derived/plumbing-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/landscaping-1.jpg": {
    "base": "/images/derived/landscaping-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/painting-1.jpg": {
    "base": "/images/derived/painting-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/pest-control-1.jpg": {
    "base": "/images/derived/pest-control-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/hvac-1.jpg": {
    "base": "/images/derived/hvac-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/roofing-1.jpg": {
    "base": "/images/derived/roofing-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": false
  },
  "/images/construction-2.jpg": {
    "base": "/images/derived/construction-2",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/interior-4.jpg": {
    "base": "/images/derived/interior-4",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/trades-1.jpg": {
    "base": "/images/derived/trades-1",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/trades-2.jpg": {
    "base": "/images/derived/trades-2",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/construction-plans.jpg": {
    "base": "/images/derived/construction-plans",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/renovation-progress.jpg": {
    "base": "/images/derived/renovation-progress",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/roofing-install.jpg": {
    "base": "/images/derived/roofing-install",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/plumbing-heater.jpg": {
    "base": "/images/derived/plumbing-heater",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/painting-detail.jpg": {
    "base": "/images/derived/painting-detail",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/cleaning-crew.jpg": {
    "base": "/images/derived/cleaning-crew",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/landscaping-finished.jpg": {
    "base": "/images/derived/landscaping-finished",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": true,
    "webp": true
  },
  "/images/hvac-maintenance.jpg": {
    "base": "/images/derived/hvac-maintenance",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/electrical-diagnosis.jpg": {
    "base": "/images/derived/electrical-diagnosis",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/pest-inspection.jpg": {
    "base": "/images/derived/pest-inspection",
    "widths": [
      400,
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/bathroom-1.jpg": {
    "base": "/images/derived/bathroom-1",
    "widths": [
      400,
      800
    ],
    "avif": false,
    "webp": true
  },
  "/images/living-1.jpg": {
    "base": "/images/derived/living-1",
    "widths": [
      400,
      800
    ],
    "avif": false,
    "webp": true
  },
  "/images/construction-1.jpg": {
    "base": "/images/derived/construction-1",
    "widths": [
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/home-exterior-1.jpg": {
    "base": "/images/derived/home-exterior-1",
    "widths": [
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/home-exterior-2.jpg": {
    "base": "/images/derived/home-exterior-2",
    "widths": [
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  },
  "/images/strategy-1.jpg": {
    "base": "/images/derived/strategy-1",
    "widths": [
      800,
      1200,
      1600
    ],
    "avif": false,
    "webp": true
  }
};

export function derivativesFor(src){ return DERIVATIVES[src] || null; }
